<template>
    <div>
        <v-card>
            <v-toolbar color="primary" dark>
                <v-toolbar-title style="padding-left: 10px">{{$t(createFormName)}}</v-toolbar-title>
            </v-toolbar>
            <v-form id="createForm" @keyup.enter.native="onSave" v-model="formValid" lazy-validation ref="createForm">
                <v-layout wrap>
                    <v-flex xs12 style="padding: 10px">
                        <v-text-field append-icon="code" v-validate="'required'"
                                      :label="$t('lang.customer.customerName')"
                                      :data-vv-as="$t('lang.customer.customerName')"
                                      v-model="values['customerName']"
                                      name="customerName"
                                      :error-messages="errors.first('customerName')"
                        ></v-text-field>
                        <v-text-field append-icon="class" v-validate="'required|email'"
                                      :label="$t('lang.customer.email')"
                                      :data-vv-as="$t('lang.customer.email')"
                                      v-model="values['email']"
                                      name="email"
                                      :error-messages="errors.first('email')"
                        ></v-text-field>
                        <v-text-field append-icon="" v-validate="'required'"
                                      :label="$t('lang.customer.contact')"
                                      :data-vv-as="$t('lang.customer.contact')"
                                      v-model="values['contact']"
                                      name="contact"
                                      :error-messages="errors.first('contact')"
                        ></v-text-field>
                        <v-text-field append-icon="" v-validate="'required'"
                                      :label="$t('lang.customer.agentAddress')"
                                      :data-vv-as="$t('lang.customer.agentAddress')"
                                      v-model="values['agentAddress']"
                                      name="agentAddress"
                                      :error-messages="errors.first('agentAddress')"
                        ></v-text-field>
                        <v-text-field append-icon="" v-validate="'required'"
                                      :label="$t('lang.customer.code')"
                                      :data-vv-as="$t('lang.customer.code')"
                                      v-model="values['code']"
                                      name="code"
                                      :error-messages="errors.first('code')"
                        ></v-text-field>
                        <v-text-field append-icon="class" v-validate="'required|phone'"
                                      :label="$t('lang.customer.phone')"
                                      :data-vv-as="$t('lang.customer.phone')"
                                      v-model="values['phone']"
                                      name="phone"
                                      :error-messages="errors.first('phone')"
                        ></v-text-field>
                        <v-select :items="customerTypes" :label="$t('lang.customer.customerType')"
                                  v-model="values['customerType']"
                                  name="l"
                                  item-value="categoryId"
                                  item-text="categoryName"
                                  v-validate="'required'"
                                  :data-vv-as="$t('lang.customer.customerType')"
                                  :error-messages="errors.first('customerType')"
                        />

                        <v-select :items="languages" :label="$t('lang.customer.language')"
                                  v-model="values['language']"
                                  name="language"
                                  item-value="categoryCode"
                                  item-text="categoryName"
                                  v-validate="'required'"
                                  :data-vv-as="$t('lang.customer.language')"
                                  :error-messages="errors.first('language')"
                        />

                        <v-select :items="countrys" :label="$t('lang.customer.country')"
                                  v-model="values['country']"
                                  name="country"
                                  item-value="categoryCode"
                                  item-text="categoryName"
                                  v-validate="'required'"
                                  :data-vv-as="$t('lang.customer.country')"
                                  :error-messages="errors.first('country')"
                        />
                        <v-select :items="manageIds" :label="$t('lang.customer.manageId')"
                                  v-model="values['manageId']"
                                  name="manageId"
                                  item-value="userId"
                                  item-text="fullName"
                                  v-validate="'required'"
                                  :data-vv-as="$t('lang.customer.manageId')"
                                  :error-messages="errors.first('manageId')"
                        />
                        <v-text-field append-icon="class" v-validate=""
                                      :label="$t('lang.customer.discount')"
                                      :data-vv-as="$t('lang.customer.discount')"
                                      v-model="values['discount']"
                                      name="discount"
                                      :error-messages="errors.first('discount')"
                        ></v-text-field>

                    </v-flex>
                </v-layout>
            </v-form>
            <div style="text-align: right">
                <v-btn color="primary" @click="onSave">
                    <v-icon dark left>save</v-icon>
                    {{$t('lang.common.save')}}
                </v-btn>
                <v-btn color="primary" v-if="enableDelete==true" @click="onDelete">
                    <v-icon dark left>delete</v-icon>
                    {{$t('lang.common.delete')}}
                </v-btn>
                <v-btn color="error" @click="onCancel">
                    <v-icon dark left>cancel</v-icon>
                    {{$t('lang.common.cancel')}}
                </v-btn>
            </div>
        </v-card>
    </div>
</template>

<script>
    import Validator from "../../../../../public/js/validator";
    import axios from "axios";
    import {message} from "@/shared/message";

    const v = Validator();
    console.log("---v---");
    console.log(v);

    export default {
        name: 'customer-create',
        components: {Validator},
        inheritAttrs: true,
        props: {
            enableDelete: {
                type: Boolean,
                default: false
            },
            createFormName: {
                type: String,
                default: 'Create Form'
            },
            inputItems: {
                type: Array,
                default: () => []
            },
            createUrl: {
                type: String,
                default: ""
            },
            deleteUrl: {
                type: String,
                default: ""
            },
            column: {
                type: String,
                default: "12"
            },
            defaultData: {
                type: Object,
                default: () => {
                    return {}
                }
            }
        },
        data: () => {
            return {
                formValid: false,
                values: {},
                model: {},
                customerTypes: [],
                languages: [],
                countrys: [],
                manageIds: [],
            }
        },
        watch: {
            defaultData: function (value) {
                console.log("defaultData", this.value);
                this.values = this.copyValue(value);
            },
            formValid: function (value) {
                console.log("formValid", this.formValid);
            }
        },
        methods: {
            copyValue: function (value) {
                console.log("copy function");
                let ob = {};
                for (let key in value) {
                    ob[key] = value[key];
                }
                return ob;
            },
            onSave: function () {
                console.log("v", this.values);
                this.$validator.validate().then(
                    valid => {
                        if (!valid) {
                            message.error(this.$t('lang.common.validate_fail'));
                            return;
                        }
                        axios.post(process.env.VUE_APP_API_URL + this.createUrl, this.values).then(data => {
                            if (data.success) {
                                message.success(this.$t("lang.common.save_success"));
                                this.$emit("save", this.values);
                                this.onCancel();
                            } else {
                                message.error(this.$t(data.description));
                            }
                        }, error => {
                            message.error(error);
                        });

                    }
                )
            },

            onView: function (value) {
                this.values = value;
                //this.formValid = true;
                this.customerType = null;
                // for (let i = 0; i < this.customerTypes.length; i++) {
                //     if (this.customerTypes[i].categoryId == value.customerType) {
                //         this.customerType = this.customerTypes[i];
                //         break;
                //     }
                // }
                this.$refs.createForm.resetValidation();
            }
            ,

            onDelete: function () {
                if (confirm(this.$t("lang.common.deleteConfirm"))) {
                    axios.post(process.env.VUE_APP_API_URL + this.deleteUrl, this.values).then(data => {
                        message.success(this.$t("lang.common.delete_success"));
                        this.$emit("cancel");
                    }, error => {
                        message.error(this.$t("lang.common.deleteError"));
                    });
                }
                ;
            }
            ,

            onCancel: function () {
                try {
                    if (document.getElementById("searchDiv") != null)
                        document.getElementById("searchDiv").style.display = "";
                    if (document.getElementById("createDiv") != null)
                        document.getElementById("createDiv").style.display = "none";
                    console.log(this.$parent);
                    this.$parent.onSearch();
                } catch (e) {
                    console.log(e);
                }
                this.$emit("cancel");
            }
            ,


        },

        created() {
            axios.post(process.env.VUE_APP_API_URL + "/category/listByType?type=customertype").then(
                data => {
                    this.customerTypes = data;
                },
                error => {
                    console.log(error);
                }
            )
            axios.post(process.env.VUE_APP_API_URL + "/category/listByType?type=language").then(
                data => {
                    this.languages = data;
                },
                error => {
                    console.log(error);
                }
            )
            axios.post(process.env.VUE_APP_API_URL + "/category/listByType?type=country").then(
                data => {
                    this.countrys = data;
                },
                error => {
                    console.log(error);
                }
            ),
                axios.get(process.env.VUE_APP_API_URL + "/user/all").then(
                    data => {
                        console.log("user", data);
                        this.manageIds = data;
                    },
                    error => {
                        console.log(error);
                    }
                )
        },


    }
</script>
